import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LaundryIssuedApi } from '../api/laundryissued.api';
import { switchMap, map } from 'rxjs/operators';
import {LaundryItemData}  from '../../../interfaces/masters/laundryitem';


import { LaundryIssuedData, LaundryIssued, LaundryIssuedDetail,FrontList, QuickList } from '../../../interfaces/masters/laundryissued' ;
@Injectable()
export class LaundryIssuedService extends LaundryIssuedData {

    constructor(private api: LaundryIssuedApi) {
      super();
    }
  // listDistinctItems(url: string): Observable<any>{
  //   return this.api.listDistinctItems(url);
  // }
  
    list(url: string): Observable<LaundryIssued[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<LaundryIssued>{
        return this.api.getById(url);
    }
  
    create(url: string, data:LaundryIssued): Observable<LaundryIssued> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:LaundryIssued): Observable<LaundryIssued> {
      return this.api.update(url,data);
    }
    listDetail(url: string): Observable<LaundryIssuedDetail[]> {
      return this.api.listDetail(url);
    }
    frontList(url: string): Observable<FrontList[]> {
      return this.api.frontList(url);
    }
    quickList(url: string): Observable<QuickList[]> {
      return this.api.quickList(url);
    }
    
   
    createDetail(url: string, data:LaundryIssuedDetail[]): Observable<LaundryIssuedDetail> {
      return this.api.addDetail(url,data);
    }
    updateDetail(url: string, data:LaundryIssuedDetail[]): Observable<LaundryIssuedDetail> {
      return this.api.updateDetail(url,data);
    }
    deleteDetail(url: string): Observable<boolean> {
      return this.api.deleteDetail(url);
    }
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }